import { QueryKeys } from "@/constants";
import httpClient from "@/services";
import { useMutation } from "@tanstack/react-query";
import type { IUserInfo } from "./use-user-info";
const ebixRequest = async (
  info: IUserInfo,
  password: string,
  resource: string,
) => {
  const payloadData = {
    username: info.username,
    password,
    ebixGroup: info.loginGroupId,
    page: resource,
  };

  const config = {
    method: "POST",
    url: "saml/ebixHub",
    headers: {
      Authorization: `Bearer ${info.accessToken}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
    data: payloadData,
  };

  return httpClient.request(config).then((response) => response.data);
};

const hccbRequest = async (userInfo: IUserInfo, ssoId: string = "") => {
  const payloadData = {
    ssoId,
    username: userInfo.username,
  };

  const config = {
    method: "POST",
    url: "saml/metadata",
    headers: {
      Authorization: `Bearer ${userInfo.accessToken}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
    data: payloadData,
  };

  return httpClient.request(config).then((response) => response.data);
};

export type IEbixRequest = {
  info: IUserInfo;
  password: string;
  resource: string;
};

export type IHccbRequest = {
  info: IUserInfo;
};

export const useMEbix = () => {
  return useMutation({
    mutationKey: [QueryKeys.EBIX],
    mutationFn: (params: IEbixRequest) =>
      ebixRequest(params.info, params.password, params.resource),
    // onSuccess: (data) => {
    //   console.log("Test123 Ebix request successful:", data);
    // },
    // onError: (error) => {
    //   console.error("Ebix request failed:", error);
    // },
    retry: false,
  });
};

export const useMHccb = (ssoId: string) => {
  return useMutation({
    mutationKey: [QueryKeys.HCCB],
    mutationFn: (params: IHccbRequest) => hccbRequest(params.info, ssoId),
    retry: false,
  });
};
